import { components } from '@/generated/internal-api/openapi-types';

export type ISODate = string;
export type ISODateTime = string;
export type ID = string | number;
export type ApiID<EntityPredix extends string = string> = `${EntityPredix}_${string}`;
export type TempApiID<EntityPredix extends string = string> = ApiID<`~${EntityPredix}`>;
export type Color = components['schemas']['Color.schema'];
export type Nullable<T> = T | null | undefined;
export type MapKeyType<T> = T extends Map<infer K, any> ? K : never;
export type MapValueType<T> = T extends Map<any, infer K> ? K : never;
export type UUID = ReturnType<Crypto['randomUUID']>;
export type SetElementType<S> = S extends Set<infer T> ? T : never;

declare const brand: unique symbol;
export type Brand<T, Brand extends string> = T & { [brand]: Brand };

export type RequiredNonNil<T> = {
  [P in keyof T]-?: Exclude<T[P], null | undefined>;
};
export type PickRequired<T, K extends keyof T> = T & RequiredNonNil<Pick<T, K>>;
export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[]
  ? ElementType
  : never;
export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type Prettify<T> = {
  [K in keyof T]: Prettify<T[K]>;
} & {};

export type NumericString = components['schemas']['NumericString.schema'];
export interface Entity {
  id: ID;
  created_at: ISODateTime;
  updated_at?: ISODateTime;
}

export interface HasApiId<API extends string> {
  api_id: ApiID<API>;
}

export interface DataWrapper<Data> {
  data: Data;
}

export enum Order {
  asc = 'asc',
  desc = 'desc',
}

export interface JwtPayload {
  iss: string;
  iat: number;
  exp: number;
  nbf: number;
  jti: string;
  sub: string;
  prv: string;
  type: string;
}

export type DatabaseId = components['schemas']['DatabaseId.schema'];
